import React from 'react';
import { useStore } from 'effector-react';
import { HSIconType } from '@types';
import { $editingHotspot } from '@stores/editingHotspotStores';

function PolygonTip() {
  const editing = useStore($editingHotspot);
  if (
    editing?.hotspot.icon.type !== HSIconType.polygon ||
    !!editing?.hotspot.icon.points?.length
  ) {
    return null;
  }
  return (
    <div className="absolute flex h-30 items-center rounded bg-orange px-10">
      {editing?.hotspot.locked
        ? '当前热点已被锁定，暂不支持绘制多边形，请先取消锁定后再编辑绘制'
        : '点击任意位置开始绘制多边形，拖动热点标题调整标题位置'}
    </div>
  );
}

export default PolygonTip;
